import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Modal from '~/commons/components/Modal.jsx';

const setPopCookie = (ann) => {
  const { path = 'app' } = ann;
  const name = `last.popped.ann.${path}.${ann.popupFreq}`;
  const popped = localStorage.getItem(name);

  if (ann._id !== popped) {
    localStorage.setItem(name, ann._id);

    return true;
  }

  return false;
};

const ModalAnnouncement = ({ path = 'app' }) => {
  const [show, setShow] = useState(false);
  const [content, setContent] = useState(null);
  const [, req] = useHttpStatus({
    onSuccess({ data: { once, everyday } = {} }) {
      console.log('ModalAnnouncement data----', once, everyday);
      if (once && setPopCookie(once)) {
        setContent(once);
        setShow(true);
      } else if (everyday && setPopCookie(everyday)) {
        setContent(everyday);
        setShow(true);
      }
    },
  });
  useEffect(() => {
    req({
      url: '/api/site/announcements/popup',
    });
  }, []);

  if (!content) return '';

  const img = content.coverImg ? (
    <img className="w-100" src={content.coverImg} alt={content.title} />
  ) : (
    ''
  );

  return content ? (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      size="lg"
      className="p-0"
    >
      {path === 'app' ? (
        <Link
          to={`/app/announcements/${content._id}`}
          onClick={() => setShow(false)}
        >
          {img}
        </Link>
      ) : (
        <a
          href={`/announcements/${content._id}`}
          onClick={() => setShow(false)}
        >
          {img}
        </a>
      )}
    </Modal>
  ) : (
    ''
  );
};

export default ModalAnnouncement;
